module.exports = "<div class=\"date-option\">\n  <p-calendar dateFormat=\"yy-mm-dd\" [(ngModel)]=\"dateDefualt\" name=\"dateDefualt\" [locale]=\"cn\" (onSelect)=\"getDate($event)\"\n    [monthNavigator]=\"true\" [yearNavigator]=\"true\" yearRange=\"1970:2030\" [placeholder]=\"placeHolder\"></p-calendar>\n  <!-- appendTo=\"body\" -->\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/user/date-option/date-option.component.html
// module id = ../../../../../src/app/user/date-option/date-option.component.html
// module chunks = common